import { render, staticRenderFns } from "./BindPhone.vue?vue&type=template&id=16bd806e&"
import script from "./BindPhone.vue?vue&type=script&lang=js&"
export * from "./BindPhone.vue?vue&type=script&lang=js&"
import style0 from "./BindPhone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports